<template>
    <video class="front-video"
           :ref="'video'"
           :src="source"
           :style="`z-index:${zIndex}`"
           type="video/mp4"
           muted
           @click="pause"
           @ended="ended">
        Sorry, video is not supported
    </video>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'Video',
        computed: {
            ...mapState([
                 'paused'
            ]),
            ref() {
                return this.$refs['video'];
            },
            source() {
                return `${this.video.video_src}`;
            },
            zIndex() {
                return this.index === this.topIndex ? 1 : 0;
            }
        },
        methods: {
            // using canPlay instead of canPlayThrough because latter causes 1ms pause at beginning in Safari
            ended() {
                this.$emit('ended', this.index);
            },
            pause() {
                if (!this.paused) {
                    this.$store.commit('setPaused', true);
                    this.ref.pause();
                } else {
                    this.$store.commit('setPaused', false);
                    this.play();
                }
            },
            play() {
                this.ref.play();
            },
            reset(){
                this.ref.currentTime = 0;
            }
        },
        props: {
            index: Number,
            topIndex: Number,
            video: Object,
        },
    }
</script>

<style lang="scss">

    .front-video {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        min-width: 100%;
        min-height: 100%;
        width: 100%;
        object-fit: cover;
    }

</style>
